
import { getLocationSelected, getGroupSelected, getGroupLocation} from "../../redux/actions/admin-index";

export const selectFirstLocation = (dispatch, id) => {
    dispatch(getLocationSelected(id))
    localStorage.setItem('location', id);
    dispatch(getGroupSelected(""))
    localStorage.setItem('group', "");
}

export const selectAllGroups = (dispatch) => {
    dispatch(getLocationSelected("all"))
    localStorage.setItem('location', "all");
    dispatch(getGroupSelected(""))
    localStorage.setItem('group', "");
}

export const selectLocationOrGroup = (dispatch, locationId, groupId = "", groupLocation = "") => {
    dispatch(getLocationSelected(locationId));
    dispatch(getGroupSelected(groupId));
    dispatch(getGroupLocation(groupLocation));

    localStorage.setItem('location', locationId);
    localStorage.setItem('group', groupId);
    localStorage.setItem('location_of_group', groupLocation);
}